/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewBTechsAggregatedRecord } from './CRSFSecReviewBTechsAggregatedRecord';
import {
    CRSFSecReviewBTechsAggregatedRecordFromJSON,
    CRSFSecReviewBTechsAggregatedRecordFromJSONTyped,
    CRSFSecReviewBTechsAggregatedRecordToJSON,
} from './CRSFSecReviewBTechsAggregatedRecord';
import type { CRSFSecReviewTechSourceType } from './CRSFSecReviewTechSourceType';
import {
    CRSFSecReviewTechSourceTypeFromJSON,
    CRSFSecReviewTechSourceTypeFromJSONTyped,
    CRSFSecReviewTechSourceTypeToJSON,
} from './CRSFSecReviewTechSourceType';
import type { CRSFSecReviewTechsAggregatedRecord } from './CRSFSecReviewTechsAggregatedRecord';
import {
    CRSFSecReviewTechsAggregatedRecordFromJSON,
    CRSFSecReviewTechsAggregatedRecordFromJSONTyped,
    CRSFSecReviewTechsAggregatedRecordToJSON,
} from './CRSFSecReviewTechsAggregatedRecord';
import type { CRSFSecReviewWTechsAggregatedRecord } from './CRSFSecReviewWTechsAggregatedRecord';
import {
    CRSFSecReviewWTechsAggregatedRecordFromJSON,
    CRSFSecReviewWTechsAggregatedRecordFromJSONTyped,
    CRSFSecReviewWTechsAggregatedRecordToJSON,
} from './CRSFSecReviewWTechsAggregatedRecord';

/**
 * 
 * @export
 * @interface TechnologiesInner1
 */
export interface TechnologiesInner1 {
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner1
     */
    asset: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TechnologiesInner1
     */
    category: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TechnologiesInner1
     */
    created: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TechnologiesInner1
     */
    cves: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TechnologiesInner1
     */
    data: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof TechnologiesInner1
     */
    found: number;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner1
     */
    module: string;
    /**
     * 
     * @type {number}
     * @memberof TechnologiesInner1
     */
    port: number;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner1
     */
    process_id: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner1
     */
    protocol: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner1
     */
    se_version?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TechnologiesInner1
     */
    shared: boolean;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner1
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner1
     */
    source_asset: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner1
     */
    tech_key: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner1
     */
    tech_name: string;
    /**
     * 
     * @type {CRSFSecReviewTechSourceType}
     * @memberof TechnologiesInner1
     */
    tech_source?: CRSFSecReviewTechSourceType;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner1
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologiesInner1
     */
    cpe: string;
}

/**
 * Check if a given object implements the TechnologiesInner1 interface.
 */
export function instanceOfTechnologiesInner1(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "cves" in value;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "found" in value;
    isInstance = isInstance && "module" in value;
    isInstance = isInstance && "port" in value;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "protocol" in value;
    isInstance = isInstance && "shared" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "source_asset" in value;
    isInstance = isInstance && "tech_key" in value;
    isInstance = isInstance && "tech_name" in value;
    isInstance = isInstance && "version" in value;
    isInstance = isInstance && "cpe" in value;

    return isInstance;
}

export function TechnologiesInner1FromJSON(json: any): TechnologiesInner1 {
    return TechnologiesInner1FromJSONTyped(json, false);
}

export function TechnologiesInner1FromJSONTyped(json: any, ignoreDiscriminator: boolean): TechnologiesInner1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'category': json['category'],
        'created': json['created'],
        'cves': json['cves'],
        'data': json['data'],
        'found': json['found'],
        'module': json['module'],
        'port': json['port'],
        'process_id': json['process_id'],
        'protocol': json['protocol'],
        'se_version': !exists(json, 'se_version') ? undefined : json['se_version'],
        'shared': json['shared'],
        'source': json['source'],
        'source_asset': json['source_asset'],
        'tech_key': json['tech_key'],
        'tech_name': json['tech_name'],
        'tech_source': !exists(json, 'tech_source') ? undefined : CRSFSecReviewTechSourceTypeFromJSON(json['tech_source']),
        'version': json['version'],
        'cpe': json['cpe'],
    };
}

export function TechnologiesInner1ToJSON(value?: TechnologiesInner1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'category': value.category,
        'created': value.created,
        'cves': value.cves,
        'data': value.data,
        'found': value.found,
        'module': value.module,
        'port': value.port,
        'process_id': value.process_id,
        'protocol': value.protocol,
        'se_version': value.se_version,
        'shared': value.shared,
        'source': value.source,
        'source_asset': value.source_asset,
        'tech_key': value.tech_key,
        'tech_name': value.tech_name,
        'tech_source': CRSFSecReviewTechSourceTypeToJSON(value.tech_source),
        'version': value.version,
        'cpe': value.cpe,
    };
}

